import { FC } from 'react';
import { Rule } from 'antd/es/form';
import { useQuery } from '@apollo/client';
import { ComponentQueryLoader } from '../component-query-loader';
import { lookupHealthProfessionQuery } from './health-profession-dropdpwn-query';
import { HealthProfessionDropdown } from './health-profession-dropdown';

export interface HealthProfessionDropdownContainerProps {
  name?: string | (string | number)[];
  rules?: Rule[]
  label?: string;
  placeholder?: string;
  style?: React.CSSProperties;
  allHealthProfessionData?: any;
}
export const HealthProfessionDropdownContainer: FC<HealthProfessionDropdownContainerProps> = (props) => {
  
  const { data: healthProfessionInfo, loading:healthProfessionLoading, error:healthProfessionError} = useQuery(lookupHealthProfessionQuery, {
    context: { clientName: 'unauthorized' }
  });

 return (
   <ComponentQueryLoader
   loading={healthProfessionLoading}
   error={healthProfessionError}
   hasData={healthProfessionInfo?.healthProfessionsData?.healthProfessions}
   hasDataComponent={<HealthProfessionDropdown
   {...props}
   allHealthProfessionData ={healthProfessionInfo?.healthProfessionsData?.healthProfessions}/>}
     
   />
 );
}